import { Stack, StackProps, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface IStyledWhiteBoxProps extends StackProps {
  children: ReactNode;
}

const StyledWhiteBox = (props: IStyledWhiteBoxProps) => {
  const theme = useTheme();

  return (
    <Stack bgcolor={theme.palette.background.default} borderRadius={theme.shape.borderRadius / 2} {...props}>
      {props.children}
    </Stack>
  );
};

export default StyledWhiteBox;
